import { useEffect, useRef, useState } from "react";

type Props = { deps: (string | number | boolean)[] };

export function useDebounce() {
    const [timerId, setTimerId] = useState<NodeJS.Timeout | null>(null);
    //
    const change = useRef(0);

    //
    function debounce(callback: () => void, timeout = 2000) {
        if (timeout <= 0) {
            throw new Error("Delay should be a positive number");
        }

        change.current++;
        const newChange = change.current;

        const id = setTimeout(() => {
            if (newChange === change.current) {
                callback();
                change.current = 0;
            }
        }, timeout);

        setTimerId(id);
    }

    //
    useEffect(() => {
        return () => setTimerId(null);
    }, []);

    return debounce;
}
